import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Add";
//import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import {
  cardTitle,
  roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";
const styles = {
  cardTitle,
  cardTitleWhite: {
    ...cardTitle,
    color: "#FFFFFF",
    marginTop: "0"
  },
  cardCategoryWhite: {
    margin: "0",
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: ".875rem"
  },
  cardCategory: {
    color: "#999999",
    marginTop: "10px"
  },
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  iconRose: {
    color: roseColor
  },
  marginTop30: {
    marginTop: "30px"
  },
  testimonialIcon: {
    marginTop: "30px",
    "& svg": {
      width: "40px",
      height: "40px"
    }
  },
  cardTestimonialDescription: {
    fontStyle: "italic",
    color: "#999999"
  }
};

class AddNewCard extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick = () => {
    this.props.handleClick(this.props.ad_space);
  };
  render() {
    const { classes, cardHeight, cardWidth } = this.props;
    return (
      <Card
        pricing
        onClick={this.handleClick}
        style={{ cursor: "pointer", width: cardWidth, height: cardHeight }}
      >
        <CardBody pricing>
          {/* <h6 className={classes.cardCategory}>New Ad</h6> */}
          <div className={classes.icon}>
            <Home className={classes.iconRose} />
          </div>
          <p className={classes.cardDescription} />
          {/* <Button round color="rose" onClick={this.handleClick}>
            Add New
          </Button> */}
        </CardBody>
      </Card>
    );
  }
}

AddNewCard.propTypes = {
  handleClick: PropTypes.func.isRequired,
  ad_space: PropTypes.string.isRequired
};

export default withStyles(styles)(AddNewCard);



// WEBPACK FOOTER //
// ./src/views/Cards/AddNewCard.jsx